import React from "react";
import { useDraggable, useDroppable } from "@dnd-kit/core";
import { useSelector } from "react-redux";
import { UnpublishedPlanObjectiveAccordionItem } from "../UnpublishedPlanObjectiveAccordionItem";

export const UnpublishedPlanDraggableAndDroppable = ({
  id,
  children,
  businessPlanId,
  index,
  item,
  showRemovePracticePopup,
  setShowRemovePracticePopup,
  showConfirmationButtons,
  setShowConfirmationButtons,
  isLastObjective,
  hideDraggable,
  isPlanPublished,
  callBack,
  isViewMode,
  editMode,
  closeAllAccordions,
  showActions,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef: setDraggableRef,
    transform: dragTransform,
  } = useDraggable({
    id: `${index}`,
  });
  const userProfile = useSelector((state) => state.authDetails.userProfile);
  const { setNodeRef: setDroppableRef, isOver } = useDroppable({
    id: `${index}`,
  });

  const setNodeRef = (node) => {
    setDraggableRef(node);
    setDroppableRef(node);
  };

  const style = {
    transform: dragTransform
      ? `translate3d(${dragTransform.x}px, ${dragTransform.y}px, 0)`
      : undefined,
    backgroundColor: isOver ? "#e9ecef" : undefined,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <UnpublishedPlanObjectiveAccordionItem
        {...props}
        isViewMode={isViewMode}
        editMode={editMode}
        item={item}
        businessPlanId={businessPlanId}
        isLastObjective={isLastObjective}
        showConfirmationButtons={showConfirmationButtons}
        setShowConfirmationButtons={setShowConfirmationButtons}
        showRemovePracticePopup={showRemovePracticePopup}
        setShowRemovePracticePopup={setShowRemovePracticePopup}
        // isOwner={userProfile.id === item.ownerId}
        callBack={callBack}
        isPlanPublished={isPlanPublished}
        hideDraggable={hideDraggable}
        dragHandleProps={{ ...attributes, ...listeners }}
        closeAllAccordions={closeAllAccordions}
        index={index}
        showActions={showActions}
      >
        {children}
      </UnpublishedPlanObjectiveAccordionItem>
    </div>
  );
};
